import { MAIN_COLOR } from 'shared/consts';
import styled from 'styled-components';

export const MarginBottom = styled.div`
	margin-bottom: 40px;
`;

export const Circle = styled.div`
	width: 100px;
	height: 100px;
	border-radius: 100%;
	background: ${MAIN_COLOR};
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 16px;
	font-weight: 600;
`;

export const ButtonsContainer = styled.div`
	margin-left: 50px;
	margin-right: 50px;
`;
